module.exports = __webpack_public_path__ + "static/media/fl_cast_jmorrison.f112fcfb.jpg";